<div
  [style.padding-left.px]="calculatedLeftPadding()"
  class="flex w-full justify-between items-center p-2 gap-2 group hover:bg-proffeo-surface-muted transition-default border-b border-proffeo-overlay-subtle"
>
  <div class="flex gap-2.5 items-center w-[50%]">
    <mat-icon
      (click)="toggleExpanded()"
      [fontIcon]="expanded() ? 'stat_minus_1' : 'chevron_forward'"
      [class.opacity-0]="!hasChildGroups()"
      [class.pointer-events-none]="!hasChildGroups()"
      class="cursor-pointer hover:icon-accent transition-default icon-lg"
    />
    <mat-icon
      fontIcon="groups"
      class="max-md:hidden!"
    />
    <p class="text-proffeo-text truncate max-md:text-xs">
      {{ companyGroup().name }}
    </p>
    <div
      class="opacity-0 max-md:hidden flex pointer-events-none transition-all transition-150 gap-1.5 items-center group-hover:opacity-100 group-hover:pointer-events-auto"
    >
      <mat-icon
        (click)="openCreateCompanyGroupDialog(companyGroup().id)"
        fontIcon="add_box"
        class="hover:icon-danger! transition-all transition-150 cursor-pointer"
      />
      <mat-icon
        (click)="openEditCompanyGroupNameDialog(companyGroup())"
        fontIcon="edit_square"
        class="hover:icon-danger! transition-all transition-150 cursor-pointer"
      />
      <mat-icon
        (click)="openGroupDeleteConfirmationDialog(companyGroup())"
        fontIcon="delete"
        class="hover:icon-danger! transition-all transition-150 cursor-pointer"
      />
    </div>
  </div>
  <div class="flex items-center w-[32.5%] md:w-[180px]">
    @if (companyGroup().users()?.length) {
      <proffeo-avatar
        (click)="selectGroupAdmin($safeNavigationMigration(groupAdmin()?.applicationUser()))"
        [user]="$safeNavigationMigration(groupAdmin()?.applicationUser())"
        [size]="AvatarSize.SM"
        [style.z-index]="companyGroup().users().length"
        [borderType]="AvatarBorderType.IndustryAdmin"
      />

      <proffeo-group-avatars
        (click)="
          selectUsers(
            companyGroup().users(),
            $safeNavigationMigration(groupAdmin()?.applicationUser()),
            companyGroup().id
          )
        "
        [groupUsers]="groupUsers()"
        [showAvatarsCount]="isMobile() ? 1 : 2"
        [avatarSize]="AvatarSize.SM"
        class="cursor-pointer sm:ml-4"
      />
    } @else {
      <proffeo-avatar
        (click)="selectUsers(companyGroup().users(), undefined, companyGroup().id)"
        [size]="AvatarSize.SM"
      />
    }
  </div>
  <div
    [matMenuTriggerFor]="actionsMenu"
    class="items-center justify-center p-1 cursor-pointer max-md:flex hidden"
  >
    <mat-icon fontIcon="more_vert" />
  </div>
</div>
@if (expanded()) {
  @for (children of groupChildren(); track children().id) {
    <proffeo-company-groups-list-item
      [level]="level() + 1"
      [companyGroup]="children()"
    ></proffeo-company-groups-list-item>
  }
}

<mat-menu #actionsMenu="matMenu">
  <div class="flex flex-col">
    <div
      (click)="openCreateCompanyGroupDialog(companyGroup().id)"
      class="flex w-full px-3 py-1.5 gap-1.5 items-center group hover:bg-proffeo-accent cursor-pointer"
    >
      <mat-icon
        fontIcon="add_box"
        class="group-hover:icon-white transition-all transition-150 cursor-pointer"
      />
      <p class="group-hover:icon-white">{{ 'groups-add-subgroup' | translate }}</p>
    </div>
    <div
      (click)="openEditCompanyGroupNameDialog(companyGroup())"
      class="flex w-full gap-1.5 items-center group hover:bg-proffeo-accent cursor-pointer px-3 py-1.5"
    >
      <mat-icon
        fontIcon="edit_square"
        class="group-hover:icon-white transition-all transition-150 cursor-pointer"
      />
      <p class="group-hover:icon-white">{{ 'groups-rename-group' | translate }}</p>
    </div>
    <div
      (click)="openGroupDeleteConfirmationDialog(companyGroup())"
      class="flex w-full gap-1.5 items-center group hover:bg-proffeo-accent cursor-pointer px-3 py-1.5"
    >
      <mat-icon
        fontIcon="delete"
        class="group-hover:icon-white transition-all transition-150 cursor-pointer"
      />
      <p class="group-hover:icon-white">{{ 'groups-delete-confirmation' | translate }}</p>
    </div>
  </div>
</mat-menu>
